import { mxn } from "@/lib/format";

const TONO = { ERROR: "text-red-700", OMITIDA: "text-slate-500", ADVERTENCIA: "text-amber-700" };
const tono = (txt) => TONO[String(txt || "").split(":")[0]] || "text-emerald-700";
const num = (v) => (v == null ? "—" : v);

// Hoja «Creditos»: cliente, producto, monto, fecha, cuotas pagadas y la vista previa (o el resultado real).
export function TablaCreditos({ filas }) {
  if (!filas.length) return null;
  return (
    <div data-testid="migracion-tabla-creditos">
      <p className="mb-2 text-sm font-semibold text-slate-800">Créditos</p>
      <div className="max-h-96 overflow-auto rounded-md border border-slate-200">
        <table className="w-full min-w-[980px] text-sm">
          <thead className="sticky top-0 bg-slate-50 text-left text-[11px] uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-3 py-2">Fila</th><th className="px-3 py-2">Cliente</th><th className="px-3 py-2">Producto</th>
              <th className="px-3 py-2 text-right">Monto</th><th className="px-3 py-2">Fecha original</th>
              <th className="px-3 py-2 text-right">Cuotas pagadas</th><th className="px-3 py-2 text-right">Saldo previsto</th>
              <th className="px-3 py-2 text-right">Cuotas vencidas</th><th className="px-3 py-2">Resultado</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {filas.map((f) => {
              const pv = f.real || f.previa || {};
              const d = f.datos || {};
              return (
                <tr key={`c-${f.fila}`} data-testid={`migracion-credito-${f.fila}`}>
                  <td className="px-3 py-2 font-mono text-xs text-slate-500">{f.fila}</td>
                  <td className="px-3 py-2 text-slate-800">{f.nombre || f.rfc || f.curp || "—"}</td>
                  <td className="px-3 py-2 text-slate-700">{f.producto || "—"}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums">{d.monto != null ? mxn(d.monto) : "—"}</td>
                  <td className="px-3 py-2 font-mono text-xs">{d.fecha_original || "—"}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums">{num(d.migracion?.cuotas_pagadas)}</td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums" data-testid={`migracion-credito-${f.fila}-saldo`}>
                    {pv.saldo_insoluto != null ? mxn(pv.saldo_insoluto) : "—"}
                  </td>
                  <td className="px-3 py-2 text-right font-mono tabular-nums" data-testid={`migracion-credito-${f.fila}-vencidas`}>
                    {num(pv.cuotas_vencidas)}
                  </td>
                  <td className={`px-3 py-2 text-xs ${tono(f.resultado_texto)}`} data-testid={`migracion-credito-${f.fila}-resultado`}>
                    {f.resultado_texto}
                    {f.real && <span className="ml-1 text-slate-400">· saldo y vencidas reales</span>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
